module.exports = __webpack_public_path__ + "static/img/26.c9c6ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/26.png
// module id = iQa0
// module chunks = 0